/**
 * Checks to find a valid company login matching the passed in company
 * @param {object} company
 * @return {object}
 */
export default function getCompanyLogin(company) {
  const login = logins.find((c) => c.name === company);

  if (!login) {
    return null;
  }

  if (!Object.hasOwn(login, 'enabled') || !login.enabled) {
    return null;
  }

  return login;
}

const logins = [
  {
    cssClass: 'alpha',
    enabled: true,
    id: 'e8997d13-5cbe-4431-af68-70e6938b30d6',
    logo: 'alpha-logo.png',
    name: 'alpha',
    requestAccountEnabled: true,
    route: 'distributorLanding',
    windowTitle: 'Alpha Pictures | IFE Data',
  },
  {
    cssClass: 'ato',
    enabled: true,
    favicon: 'ato-favicon.png',
    hideRequestAccessFields: ['airlineClient'],
    id: '480f52e1-e546-4670-9768-2fb2ef1fbd82',
    logo: 'ato-logo.png',
    name: 'atallorder',
    requestAccountEnabled: true,
    route: 'distributorLanding',
    windowTitle: 'A Tall Order | IFE Data',
  },
  {
    cssClass: 'bbox',
    enabled: true,
    favicon: 'bbox-favicon.png',
    id: '85c98160-f687-455d-847f-a909d588de9c',
    logo: 'bbox-logo.png',
    name: 'bluebox',
    requestAccountEnabled: true,
    route: 'oemHome',
    windowTitle: 'Bluebox Aviation',
  },
  {
    cssClass: 'captive',
    enabled: false,
    id: '9fe49bd3-903d-4c4d-b4e5-8001ee19a011',
    logo: 'captive-logo.png',
    name: 'captive',
    requestAccountEnabled: true,
    route: 'distributorLanding',
    windowTitle: 'Captive | IFE Data',
  },
  {
    cssClass: 'ctino',
    enabled: false,
    id: 'd71871f4-a68c-44d0-9a18-3634951193aa',
    logo: 'ctino-logo.png',
    name: 'contentino',
    requestAccountEnabled: true,
    route: 'distributorLanding',
    windowTitle: 'Shemaroo Contentino | IFE Data',
  },
  {
    cssClass: 'dw',
    enabled: true,
    favicon: 'dw-favicon.png',
    fontUrl: 'https://fonts.googleapis.com/css2?family=Geologica:wght@100..900&display=swap',
    id: '1dca5e8b-8525-4caa-8ceb-2b0ff9182bbf',
    logo: 'dw-logo.png',
    name: 'dw',
    requestAccountEnabled: true,
    route: 'distributorLanding',
    windowTitle: 'DW | IFE Data',
  },
  {
    cssClass: 'fvs',
    enabled: true,
    favicon: 'fvs-favicon.png',
    id: '8a33de06-1757-416f-b455-b5e8aea8a186',
    logo: 'fvs-logo.png',
    name: 'fvs',
    requestAccountEnabled: false,
    route: 'airlineClientPortal',
    windowTitle: 'FVS Entertainment | IFE Data',
  },
  {
    cssClass: 'enc',
    enabled: false,
    favicon: 'enc-favicon.png',
    id: 'b9347ac5-8841-42a8-98ac-7b749862c0fc',
    logo: 'enc-logo.png',
    name: 'encore',
    requestAccountEnabled: true,
    route: 'distributorLanding',
    windowTitle: 'Encore | IFE Data',
  },
  {
    cssClass: 'f24',
    enabled: false,
    favicon: 'f24-favicon.ico',
    id: '64fde8ef-737a-449a-a2e7-bd88955945c5',
    logo: 'f24-logo.png',
    name: 'france24',
    requestAccountEnabled: true,
    route: 'distributorLanding',
    windowTitle: 'France24 | IFE Data',
  },
  {
    cssClass: 'hzn',
    enabled: false,
    favicon: 'hzn-favicon.png',
    id: '92acbd0b-03d2-42f3-86c6-ace35a5e281e',
    logo: 'hzn-logo.png',
    name: 'horizon',
    requestAccountEnabled: true,
    route: 'distributorLanding',
    windowTitle: 'Horizon | IFE Data',
  },
  {
    cssClass: 'iflix',
    enabled: true,
    id: '631769cb-bdb1-4e1a-ac8e-876fb784e72c',
    logo: 'iflix-logo.png',
    name: 'inflightflix',
    requestAccountEnabled: true,
    route: 'distributorLanding',
    windowTitle: 'InflightFlix | IFE Data',
  },
  {
    backgroundVideo: 'lgate.mp4',
    cssClass: 'lgate',
    enabled: true,
    favicon: 'lgate-favicon.png',
    id: '42bc5cee-b9ee-4ae0-b874-53ecced7e441',
    logo: 'lgate-logo.png',
    name: 'lionsgate',
    requestAccountEnabled: true,
    route: 'distributorLanding',
    windowTitle: 'Lionsgate | IFE Data',
  },
  {
    cssClass: 'mmnt',
    enabled: true,
    favicon: 'mmnt-favicon.png',
    fontUrl: 'https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',
    id: '943ef95a-e55f-4264-ab5e-dd3f7ea510ff',
    logo: 'mmnt-logo.svg',
    name: 'moment',
    requestAccountEnabled: true,
    route: 'oemHome',
    windowTitle: 'Moment',
  },
  {
    cssClass: 'pworks',
    enabled: false,
    id: '0d95a311-94ba-4c48-b051-7f89a4ca866d',
    logo: 'pworks-logo.png',
    name: 'pictureworks',
    requestAccountEnabled: true,
    route: 'distributorLanding',
    windowTitle: 'Pictureworks | IFE Data',
  },
  {
    cssClass: 'rdm',
    enabled: true,
    favicon: 'rdm-favicon.png',
    id: 'e66dff3c-f534-40f8-8ade-1cd2c16a6ed9',
    logo: 'rdm-logo.png',
    name: 'ricochet',
    requestAccountEnabled: true,
    route: 'distributorLanding',
    windowTitle: 'Ricochet Digital Media | IFE Data',
  },
  {
    cssClass: 'saf',
    enabled: true,
    favicon: 'rave-favicon.png',
    fontUrl: 'https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',
    id: '8c23767f-a386-4591-a69e-e376797ab42a',
    logo: 'rave-logo.png',
    name: 'rave',
    requestAccountEnabled: true,
    route: 'oemHome',
    windowTitle: 'RAVE Aerospace',
  },
  {
    cssClass: 'saf',
    enabled: true,
    favicon: 'saf-favicon.ico',
    fontUrl: 'https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',
    id: '8c23767f-a386-4591-a69e-e376797ab42a',
    logo: 'saf-logo.png',
    name: 'safran',
    requestAccountEnabled: true,
    route: 'oemHome',
    windowTitle: 'Safran Passenger Innovations',
  },
  {
    cssClass: 'skeye',
    enabled: false,
    favicon: 'skeye-favicon.png',
    id: '148883e9-108b-4a43-b3f8-83085e53a72e',
    logo: 'skeye-logo.png',
    name: 'skeye',
    requestAccountEnabled: true,
    route: 'distributorLanding',
    windowTitle: 'Skeye | IFE Data',
  },
  {
    cssClass: 'silk',
    enabled: true,
    favicon: 'silk-favicon.png',
    id: 'e1fc176f-49ac-4e18-9bda-5f5329abad21',
    logo: 'silk-logo.png',
    name: 'silkroute',
    requestAccountEnabled: true,
    route: 'distributorLanding',
    windowTitle: 'Silk Route Entertainment | IFE Data',
  },
  {
    cssClass: 'tsi',
    enabled: false,
    favicon: 'tsi-favicon.ico',
    id: '4f35c5bd-0113-492e-873c-a2f538946ff4',
    logo: 'tsi-footer.png',
    name: 'tsi',
    requestAccountEnabled: true,
    route: 'distributorLanding',
    windowTitle: 'Terry Steiner International | IFE Data',
  },
];
